/**
 * Safe email validation without ReDoS (no backtracking-prone regex).
 * @param {string} str
 * @returns {boolean}
 */
export function isValidEmail(str) {
  if (!str || typeof str !== 'string') return false;
  const s = str.trim();
  if (s.length > 254) return false;
  const atIndex = s.indexOf('@');
  if (atIndex <= 0 || atIndex === s.length - 1) return false;
  const domain = s.slice(atIndex + 1);
  const lastDot = domain.lastIndexOf('.');
  return lastDot > 0 && lastDot < domain.length - 1;
}
